<template>
	<div id="page">
		<div class="page-content">
			<div class="page-title page-title-small">
				<h2>
					<!--<button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>-->
					پروفایل کاربری
					<!--<button data-menu="HelpMenu" class="position-static mr-1"><i class="fa fa-question-circle helpIco"></i></button>-->
				</h2>
				<button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
				<button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
			</div>
			<div class="card header-card shape-rounded" data-card-height="100">
				<div class="card-overlay bg-highlight opacity-95"></div>
				<div class="card-overlay dark-mode-tint"></div>
			</div>
			<div class="card card-style mb-3">
				<div class="content">
					<div class="d-flex">
						<div class="d-flex align-items-center position-relative">
							<i v-if="userModel.imageFile==null || userModel.imageFile==''" class="fa fa-user-circle color-green1-dark fa-5x icon-size"></i>
							<img v-else v-bind:src="userModel.imageFile" alt="Alternate Text" width="65" height="65" class="img-fluid rounded-circle ml-3" />

							<button @click.stop="showMenu()" class="userProfile-camera-btn"><i class="fa fa-camera text-white"></i></button>
						</div>

						<div class="d-flex flex-column justify-content-start">
							<h1 class="my-1 font-weight-bolder font-18">{{userModel.title}}</h1>
							<p class="font-16 font-weight-bold">کاربر تسکینو</p>
						</div>
					</div>
				</div>
			</div>
			<div class="card card-style">
				<div class="content mb-0">
					<div class="input-style input-style-2 has-icon input-required">
						<i class="input-icon fa fa-check color-magenta2-light"></i>
						<span class="color-highlight" :class="{'input-style-1-active' : userModel.title!==null}">نام و نام خانوادگی</span>
						<input class="form-control" type="text" v-model="userModel.title" readonly>
					</div>

					<div class="input-style input-style-2 has-icon input-required">
						<i class="input-icon fa fa-check color-magenta2-light"></i>
						<span class="color-highlight" :class="{'input-style-1-active' : userModel.phoneNumber!==null}">شماره تلفن همراه</span>
						<input class="form-control ltr text-left" type="text" v-model="userModel.phoneNumber" :readonly="userModel.phoneNumberValidated==true">
						<p @click="GetRegistCode()" v-if="userModel.phoneNumberValidated!=true && userModel.phoneNumber!=null && userModel.phoneNumber!='' && isNullPhoneNumber==false" class="mt-3 font-14 text-justify">
							<i class='fa fa-exclamation-triangle text-warning font-18 ml-1'></i>
							شماره تلفن همراه اعتبارسنجی نشده است. جهت اعتبارسنجی و دریافت اعلانها از طریق SMS
							<strong class="text-warning">اینجا</strong>
							کلیک کنید.
						</p>
					</div>

					<div class="mt-2 mb-0" v-if="showRegistCode">
						<p class="font-14 text-justify">لطفا کد ارسال شده به شماره <strong>{{userModel.phoneNumber}}</strong> را وارد کنید.</p>
						<div class="input-style input-style-2 has-icon input-required mt-4">
							<i class="input-icon fa fa-lock"></i>
							<span class="color-highlight input-style-1-active input-style-1-inactive">کد فعالسازی</span>
							<input type="tel" v-model="registCode">
							<p class="text-danger" v-if="invalidRegistCode">لطفا کد فعالسازی را وارد کنید</p>
						</div>
						<button disabled id="resendButton" class="text-right btn btn-default font-14 font-weight-bold w-100 text-center" @click.prevent="GetRegistCode" type="button"><i class="fa fa-check font-10 ml-2"></i>ارسال مجدد کد</button>
						<button :disabled="Loading" class="btn btn-xxs mt-2 mb-4 btn-full bg-mint-dark rounded-sm text-uppercase font-900 w-100" @click.prevent="ValidateCode"><i class="fa fa-check font-10 ml-2"></i>ثبت کد فعالسازی</button>

					</div>


					<div class="input-style input-style-2 has-icon input-required">
						<i class="input-icon fa fa-check color-magenta2-light"></i>
						<span class="color-highlight" :class="{'input-style-1-active' : userModel.emailAddress!==null}">آدرس ایمیل</span>
						<input class="form-control ltr text-left" type="text" v-model="userModel.emailAddress" @input="v$.userModel.emailAddress.$touch()" :class="{invalid:v$.userModel.emailAddress.$error}" :readonly="userModel.emailValidated==true">
						<p class="text-danger" v-if="v$.userModel.emailAddress.email.$invalid && v$.userModel.emailAddress.$dirty">آدرس ایمیل نا معتبر می باشد.</p>
						<p @click="SendResetEmail()" v-if="userModel.emailValidated!=true && userModel.emailAddress!=null && userModel.emailAddress!='' && isNullEmail==false" class="mt-3 font-14 text-justify">
							<i class='fa fa-exclamation-triangle text-warning font-18 ml-1'></i>
							آدرس ایمیل اعتبارسنجی نشده است. جهت اعتبارسنجی و دریافت اعلانها از طریق ایمیل
							<strong class="text-warning">اینجا</strong>
							کلیک کنید.
						</p>
					</div>

					<div class="d-flex align-items-center pr-3 mb-3">
						<div class="custom-control ios-switch" style="zoom:85%">
							<input class="ios-input" id="smsNotification-checkbox" type="checkbox" v-model="userModel.smS_Notification" :disabled="userModel.phoneNumberValidated!=true">
							<label class="custom-control-label" for="smsNotification-checkbox"></label>
						</div>
						<span class="mr-5">ارسال SMS</span>
						<!--<div class="fac fac-checkbox " :class="userModel.phoneNumberValidated!=true?'fac-default':'fac-orange'">
							<span></span>
							<input id="box1-fac-checkbox" type="checkbox" v-model="userModel.smS_Notification" :disabled="userModel.phoneNumberValidated!=true">
							<label for="box1-fac-checkbox">ارسال SMS</label>
						</div>-->
					</div>
					<div class="d-flex align-items-center pr-3 mb-3">
						<div class="custom-control ios-switch" style="zoom:85%">
							<input class="ios-input" id="emailNotification-checkbox" type="checkbox" v-model="userModel.email_Notification" :disabled="userModel.emailValidated!=true">
							<label class="custom-control-label" for="emailNotification-checkbox"></label>
						</div>
						<span class="mr-5">ارسال ایمیل</span>
						<!--<div class="fac fac-checkbox" :class="userModel.emailValidated!=true?'fac-default':'fac-orange'">
							<span></span>
							<input id="box2-fac-checkbox" type="checkbox" v-model="userModel.email_Notification" :disabled="userModel.emailValidated!=true">
							<label for="box2-fac-checkbox">ارسال ایمیل</label>
						</div>-->
					</div>
					<div class="d-flex align-items-center pr-3 mb-3">
						<div class="custom-control ios-switch" style="zoom:85%">
							<input class="ios-input" id="mobileNotification-checkbox" type="checkbox" v-model="userModel.mobile_Notification">
							<label class="custom-control-label" for="mobileNotification-checkbox"></label>
						</div>
						<span class="mr-5">ارسال نوتیفیکیشن موبایل</span>
						<!--<div class="fac fac-checkbox fac-orange">
							<span></span>
							<input id="box3-fac-checkbox" type="checkbox" v-model="userModel.mobile_Notification">
							<label for="box3-fac-checkbox">ارسال نوتیفیکیشن موبایل</label>
						</div>-->
					</div>
					<!-- <div class="d-flex align-items-center pr-3 mb-3">
						<div class="custom-control ios-switch" style="zoom:85%">
							<input class="ios-input" id="userDisabled-checkbox" type="checkbox"  v-model="userModel.disabled">
							<label class="custom-control-label" for="userDisabled-checkbox"></label>
						</div>
						<span class="mr-5">ارسال نوتیفیکیشن موبایل</span>
						<div class="fac fac-checkbox fac-red">
							<span></span>
							<input id="box6-fac-checkbox" type="checkbox" v-model="userModel.disabled">
							<label for="box6-fac-checkbox">غیرفعال</label>
						</div>
					</div> -->

					<button :disabled="Loading" class="btn btn-xxs mt-4 mb-3 btn-full bg-green1-dark rounded-sm font-900 w-100" @click.prevent="CreateLocaluserList">
						<i class="fa fa-check font-10 ml-2"></i>
						ثبت
					</button>

				</div>
			</div>
		</div>

		<transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
			<div v-if="Loading" class="w-100 d-flex justify-content-center loadingBox">
				<div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید ...</div>
			</div>
		</transition>
		<Help-Menu title="معرفی موبایل اپلیکیشن تسکینو" keyEn="TaskList"></Help-Menu>

		<span data-menu="menu-language" class="optionMenu"></span>



		<div id="menu-language" class="menu menu-box-bottom menu-box-detached rounded-m" data-menu-effect="menu-over" style="display: block;">
			<div class="m-3">
				<div class="list-group list-custom-small">
					<div class="file-data position-relative line-height-xxl" id="uploadFileBtn">
						<input type="file" id="fileLoad" ref="fileInput" class="upload-file upload-file-input-menu" v-on:change="UploadFileList(1)" style="height:38px">
						<p class="upload-file-text-menu">
							<i class="fa fa-image line-height-xs color-green2-light ml-3"></i>
							<span>انتخاب تصویر</span>
							<i class="fa fa-angle-left float-left ml-2 font-10 opacity-50"></i>
						</p>
					</div>
					<div class="file-data position-relative line-height-xxl">
						<input type="file" id="fileLoad2" accept="image/*" capture ref="fileInput2" class="upload-file upload-file-input-menu" v-on:change="UploadFileList(2)" style="height:38px">
						<p class="upload-file-text-menu">
							<i class="fa fa-camera line-height-xs color-magenta1-dark ml-3"></i>
							<span>گرفتن عکس با دوربین</span>
							<i class="fa fa-angle-left float-left ml-2 font-10 opacity-50"></i>
						</p>
					</div>
					<button v-if="userModel.imageFile!=null && userModel.imageFile!=''" @click.stop="ClearUserProfileImg()" class="d-flex justify-content-between align-items-center bg-white p-0">
						<span class="d-inline-flex align-items-center">
							<i class="fa fa-trash color-red1-light float-right font-14"></i>
							حذف تصویر پروفایل
						</span>
						<i class="fa fa-angle-left"></i>
					</button>

				</div>
				<div class="clear"></div>
			</div>
		</div>

		<button id="CropperBtn" type="button" class="btn btn-xs rounded-m brand-bg-color ml-1" data-toggle="modal" data-target="#CropperModal" style="max-height:31px!important;display:none;">
			<i class="fa fa-filter text-white"></i>
		</button>
		<div id="CropperModal" class="modal fade" role="dialog">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header align-items-center">
						<h4 class="modal-title mt-0">انتخاب تصویر</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body m-0">
						<Cropper class="cropper" :src="fileString" :stencil-component="$options.components.CircleStencil" :stencil-props="{aspectRatio: 3/3,movable: true,resizable: true}" @change="CroppImge" />
						<button type="button" class="btn btn-xxs mt-3 btn-full bg-green1-dark rounded-sm font-900 w-100" data-dismiss="modal" @click="UpdaloadImgeToCdn">
							<i class="fa fa-check ml-2"></i>
							ثبت تصویر
						</button>
					</div>
				</div>
			</div>
		</div>

		<transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
			<div v-if="pageLoading" class="w-100 d-flex justify-content-center loadingBox">
				<div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید ...</div>
			</div>
		</transition>
	</div>
</template>
<script>
	import { Device } from '@capacitor/device';
	import useVuelidate from '@vuelidate/core';
	import {
		email
	} from "@vuelidate/validators";
	import 'vue-select/dist/vue-select.css';
	import HelpMenu from '../Components/HelpMenu.vue';
	import VueSimpleAlert from "vue3-simple-alert";

	import { Cropper } from 'vue-advanced-cropper'
	import 'vue-advanced-cropper/dist/style.css';

	export default {
		setup: () => ({ v$: useVuelidate() }),
		components: {
			"Help-Menu": HelpMenu,
			Cropper
		},
		data() {
			return {
				testData: null,
				registCode: null,
				invalidRegistCode: false,
				showRegistCode: false,
				pageLoading: false,
				isNullEmail: true,
				isNullPhoneNumber: true,
				logDeviceInfo: "",
				fileString: "",
				CropFileString: "",
				userModel: {
					userCode: "",
					imageBase64File: "",
					imageFile: null,
					title: null,
					orgJobTitle: 0,
					orgJobId: 0,
					userId: 0,
					disabled: false,
					adminOrUser: true,
					accessToRelativeGroup: true,
					email_Notification: false,
					smS_Notification: false,
					phoneNumber: null,
					emailAddress: null,
					mobile_Notification: false,
					emailValidated: false,
					phoneNumberValidated: false,
					validationKey: null
				},
			};
		},
		computed: {
			Loading() {
				return this.$store.getters.GetLoading;
			},

		},
		created() {
			this.GetLocaluserListItem();
		},

		methods: {
			ClearUserProfileImg() {
				document.getElementsByClassName('menu-hider')[0].click();
				VueSimpleAlert.confirm("آیا مایل به حذف تصویر خود هستید؟", null, "question", { confirmButtonText: "تایید", cancelButtonText: "انصراف" }).then(() => {
					this.$http.post("Account/ClearUserProfileImg", this.userModel)
						.then(data => {
							document.getElementById('fileLoad').value = null;
							document.getElementById('fileLoad2').value = null;
							if (data.data.isSuccess) {
								this.userModel.imageFile = "";
								this.$store.dispatch("GetUserProFileImg");
							}
							else {
								this.showErrorMessage(data.data.message);
							}
						});
				});
			},
			CroppImge({ coordinates, canvas }) {
				this.userModel.imageBase64File = canvas.toDataURL();
			},
			async UpdaloadImgeToCdn() {
				this.pageLoading = true;
				var response = await this.$http.post('Account/UpdaloadImgeToCdn', this.userModel);
				this.pageLoading = false;
				document.getElementById('fileLoad').value = null;
				document.getElementById('fileLoad2').value = null;
				if (response.data.isSuccess) {
					this.userModel.imageFile = response.data.obj;
					this.$store.dispatch("GetUserProFileImg");
				}
				else {
					this.showErrorMessage(response.data.message);
				}
			},
			async GetDeviceInfo() {
				this.logDeviceInfo = await Device.getInfo();
			},
			async UploadFileList(inputNum) {
				if (inputNum == 1) {
					this.fileList = Array.from(this.$refs.fileInput.files)
				}
				else {
					this.fileList = Array.from(this.$refs.fileInput2.files)
				}
				for (let i = 0; i < this.fileList.length; i++) {
					this.file = this.fileList[i]
					await this.UploadFile(false)
				}
			},
			showMenu() {
				document.getElementsByClassName("optionMenu")[0].click();
			},
			async UploadFile(isVoice = false) {
				document.getElementsByClassName('menu-hider')[0].click();
				let formData = new FormData();
				formData.append('file', this.file)
				this.pageLoading = true;
				var response = await this.$http.post('Account/SaveImageFile', formData);
				this.pageLoading = false;
				if (response.data.isSuccess == true) {
					this.fileString = response.data.obj;
					document.getElementById("CropperBtn").click();
				}
				else {
					this.showErrorMessage(response.data.message);
				}
			},
			GetLocaluserListItem() {
				this.pageLoading = true;
				this.$http.get("Task/GetUserItem")
					.then(data => {
						this.pageLoading = false;
						this.userModel = data.data;
						this.testData = data.data;
						if (this.userModel.emailAddress == null || this.userModel.emailAddress == "") {
							this.isNullEmail = true;
						}
						else {
							this.isNullEmail = false;
						}

						if (this.userModel.phoneNumber == null || this.userModel.phoneNumber == "") {
							this.isNullPhoneNumber = true;
						}
						else {
							this.isNullPhoneNumber = false;
						}
					});
			},
			CreateLocaluserList() {
				this.v$.$touch();
				if (!this.v$.$invalid) {
					this.$store.dispatch("UpdateUserProfile", this.userModel);
				}
			},
			SendResetEmail() {
                this.pageLoading = true;
				this.$http.get('Account/ResendEmail?email=' + this.userModel.emailAddress + "&isForgotPass=false").then(response => {
                    this.pageLoading = false;
					if (response.data == 1) {
						this.showMessage("لینک فعالسازی به آدرس ایمیل شما ارسال شد.");
					}
					else {
						this.showErrorMessage(response.data);
					}
				}, data => {
                    this.pageLoading = false;
					console.log(data);
				});
			},
			GetRegistCode() {
				this.Loading = true;

				this.$http.get('Account/ResendSms?phoneNumber=' + this.userModel.phoneNumber).then(response => {
					console.log(response);
					if (response.data == 1) {
						this.showRegistCode = true;
						this.setTimer();
					}
					else {
						this.showErrorMessage(response.data);

					}
					this.Loading = false;
				}, data => {
					console.log(data);
				});
			},
			ValidateCode() {
				if (this.registCode == "" || this.registCode == null) {
					this.invalidRegistCode = true;
					this.showErrorMessage("لطفا کد فعالسازی را وارد کنید");
					return;
				}
                this.pageLoading = true;
                this.$http.post('Account/ValidateUserPhoneNumber?phoneNumber=' + this.userModel.phoneNumber + '&registCode=' + this.registCode).then(response => {
                    this.pageLoading = false;
					if (response.data != "1") {
						this.showErrorMessage(response.data);
					}
					else {
						this.showRegistCode = false;
						this.showMessage("فعالسازی شماره تلفت همراه با موفقیت انجام شد.")
					}
  
				}, data => {
                    this.pageLoading = false;
					console.log(data);
				}, error => {
                    this.pageLoading = false;
					console.log(error);
				});
			},
			setTimer() {
				var timer2 = "5:00";
				var interval = setInterval(function () {
					var timer = timer2.split(':');
					//by parsing integer, I avoid all extra string processing
					var minutes = parseInt(timer[0], 10);
					var seconds = parseInt(timer[1], 10);
					--seconds;
					minutes = (seconds < 0) ? --minutes : minutes;
					seconds = (seconds < 0) ? 59 : seconds;
					seconds = (seconds < 10) ? '0' + seconds : seconds;
					//minutes = (minutes < 10) ?  minutes : minutes;
					document.getElementById('resendButton').innerHTML = "ارسال مجدد کد " + minutes + ':' + seconds;
					//check if both minutes and seconds are 0
					if ((seconds <= 0) && (minutes <= 0)) {
						clearInterval(interval);
						document.getElementById('resendButton').disabled = false;
						document.getElementById('resendButton').innerHTML = "ارسال مجدد کد";
					}
					timer2 = minutes + ':' + seconds;
				}, 1000);
			},
			pauseAllVid() {
				document.querySelectorAll('video').forEach(vid => vid.pause());
			},
		},
		mounted() {
			document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");
		},
		validations: {
			userModel: {
				emailAddress: {
					email
				},
			}
		},

	};
</script>
